import { ref } from '@vue/composition-api'
import html2canvas from 'html2canvas'
import { downloadImgUseALabel } from '@/util/util'

export const useDownloadCode = (id) => {
  const loading = ref(false)

  const downloadCode = (fileName) => {
    loading.value = true

    // 想要转换的dom节点
    const _canvas = document.getElementById(id)
    const w = parseInt(window.getComputedStyle(_canvas).width)
    const h = parseInt(window.getComputedStyle(_canvas).height)

    // 创建自定义 canvas 元素
    const canvas2 = document.createElement('canvas')
    const scale = 2
    canvas2.width = w * scale
    canvas2.height = h * scale

    const context = canvas2.getContext('2d')
    context.scale(scale, scale)

    const opts = {
      canvas: canvas2, // 自定义的canvas
      width: w, // dom 原始宽度
      height: h,
      useCORS: true, // 开启跨域配置
      scale: 1
    }
    html2canvas(_canvas, opts)
      .then((canvas) => {
        const imgUrl = canvas.toDataURL('image/jpeg')
        const imgName = fileName
        downloadImgUseALabel(imgUrl, imgName)
      })
      .finally(() => {
        loading.value = false
      })
  }

  return {
    loading,
    downloadCode
  }
}
